import { useState } from "react";
import Card, { SectionTitle } from "@/components/base/Card";
import Tabs from "@/components/base/Tabs";
import EnrollmentComparison from "./EnrollmentComparison";
import FinanceComparison from "./FinanceComparison";
import type { School, PlatformStat } from "@/types";

interface PlatformComparisonProps {
  schools: School[];
  stats: PlatformStat[];
}

export default function PlatformComparison({ schools, stats }: PlatformComparisonProps) {
  const [tab, setTab] = useState("effectifs");

  if (schools.length === 0 || stats.length === 0) return null;

  return (
    <Card className="mt-6">
      <SectionTitle
        title="Tableau de bord comparatif"
        subtitle="Effectifs et finances par école, sur l'année en cours"
        icon="ri-bar-chart-2-line"
        action={
          <Tabs
            active={tab}
            onChange={setTab}
            tabs={[
              { id: "effectifs", label: "Effectifs", icon: "ri-user-3-line" },
              { id: "finances", label: "Finances", icon: "ri-money-dollar-circle-line" },
            ]}
          />
        }
      />

      {tab === "effectifs" ? (
        <EnrollmentComparison schools={schools} stats={stats} />
      ) : (
        <FinanceComparison schools={schools} stats={stats} />
      )}
    </Card>
  );
}